import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import * as day from 'dayjs';
import { CommonService } from 'src/app/services/common.service';
import { ResponseMessageStatus, ResponseStatus } from 'src/app/shared/enums';
import { BadeLoftService } from '../bade-loft.service';
import moment from 'moment';
import { distinct, from } from 'rxjs';
@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css'],
})
export class OrdersComponent implements OnInit {
  isDataLoading: boolean = false;
  moment = moment;
  currentFilterDate = 1;
  quickbooksData: any[] = [];
  quickbooksDataCopy: any[] = [];
  wooCommerceData: any[] = [];
  wooCommerceDataCopy: any[] = [];
  searchTextOrder: any;
  searchTextInvoice: any;
  searchTextBLStatus: any;
  searchTextWooStatus: any;
  selectedDateRangeQBO: any = {};
  selectedDateRangeWOO: any = {};
  isLoadingQBOData: boolean = false;
  ranges: any = {
    Today: [day(), day()],
    Yesterday: [day().subtract(1, 'days'), day().subtract(1, 'days')],
    Tomorrow: [day().add(1, 'days'), day().add(1, 'days')],
    'This Week': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
    'Last 7 Days': [day().subtract(6, 'days'), day()],
    'Last 30 Days': [day().subtract(29, 'days'), day()],
    'This Month': [day().startOf('month'), day().endOf('month')],
    'Last Month': [
      day().subtract(1, 'month').startOf('month'),
      day().subtract(1, 'month').endOf('month'),
    ],
  };
  timer: any = null;
  qbDataList_Request: any;
  wooCommerceDataList_Request: any;
  isAssignmentVisible: boolean = false;
  editAssignmentDetail: any;
  assignemntForInvoice: any;
  invoiceNumber: any = '';
  fromDateQBO: any;
  toDateQBO: any;
  fromDateWOO: any;
  toDateWOO: any;
  orderStatus: any = '';
  sortDir: any = 0;
  invoiceDateSort = (a: any, b: any) =>
    a.invoiceDate.localeCompare(b.invoiceDate);
  customerNameFn = (a: any, b: any) => {
    return a.customerName.localeCompare(b.customerName);
  };

  SortquickbooksData(event: any, key: string) {
    event = event == 'ascend' ? 'descend' : 'ascend';
    if (event == 'ascend')
      this.quickbooksData.sort((a: any, b: any) =>
        a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0
      );
    if (event == 'descend')
      this.quickbooksData.sort((a: any, b: any) =>
        a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0
      );
    if (event == null) {
      this.quickbooksData = [...this.quickbooksDataCopy];
    }
  }
  SortWooCommerceData(event: any, key: string) {
    event = event == 'ascend' ? 'descend' : 'ascend';
    if (event == 'ascend') {
      this.wooCommerceData.sort((a: any, b: any) =>
        a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0
      );
    }
    if (event == 'descend') {
      this.wooCommerceData.sort((a: any, b: any) =>
        a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0
      );
    }
    if (event == null) {
      this.wooCommerceData = [...this.wooCommerceDataCopy];
    }
  }

  constructor(private _blS: BadeLoftService, public _cS: CommonService) {}

  ngOnInit(): void {
    this.selectedDateRangeQBO['startDate'] = moment().startOf('week');
    this.selectedDateRangeQBO['endDate'] = moment().endOf('week');
    this.selectedDateRangeQBO['startDate'].set({ hour: 5, minute: 30 });
    this.selectedDateRangeQBO['endDate'].set({ hour: 5, minute: 29 });
    this.selectedDateRangeWOO['startDate'] = moment().startOf('week');
    this.selectedDateRangeWOO['endDate'] = moment().endOf('week');
    this.selectedDateRangeWOO['startDate'].set({ hour: 5, minute: 30 });
    this.selectedDateRangeWOO['endDate'].set({ hour: 5, minute: 29 });
  }

  onDateChangeQBO(result: any) {
    if (result.startDate != null) {
      this.fromDateQBO = result?.startDate?.utc()?.format();
      this.toDateQBO = result?.endDate?.utc()?.format();
    }
    this.quickbooksData = [];
    // this.page = 1;
    if (this.qbDataList_Request) this.qbDataList_Request.unsubscribe();
    this.getQuickbooksData();
  }
  onDateChangeWOO(result: any) {
    if (result.startDate != null) {
      this.fromDateWOO = result?.startDate?.utc()?.format();
      this.toDateWOO = result?.endDate?.utc()?.format();
    }
    this.wooCommerceData = [];
    // this.page = 1;
    if (this.wooCommerceDataList_Request)
      this.wooCommerceDataList_Request.unsubscribe();
    this.getWooCommerceData();
  }
  searchByInvoice() {
    this.quickbooksData = this.quickbooksDataCopy.filter((x: any) =>
      x.invoiceNumber
        .toLowerCase()
        .includes(this.searchTextInvoice?.toLowerCase())
    );
  }
  searchByOrderNumber() {
    this.wooCommerceData = this.wooCommerceDataCopy.filter((x: any) =>
      x.orderNumber.toLowerCase().includes(this.searchTextOrder?.toLowerCase())
    );
  }
  searchByOrderStatus() {
    this.wooCommerceData = this.wooCommerceDataCopy.filter((x: any) =>
      x.orderStatus
        .toLowerCase()
        .includes(this.searchTextWooStatus?.toLowerCase())
    );
  }
  sort(key: string) {
    if (key == 'invoiceDate') {
      this.sortDir = 0 ? 1 : 0;
      this.quickbooksData = this.quickbooksData.sort(
        (a, b) =>
          <any>new Date(b.invoiceDate) -
          <any>new Date(a.invoiceDate) * this.sortDir
      );
    }
  }
  getQuickbooksData() {
    this.isLoadingQBOData = true;
    this.qbDataList_Request = this._blS
      .getOrdersQBO(this.invoiceNumber, this.fromDateQBO, this.toDateQBO)
      .subscribe((response: any) => {
        if (response) {
          if (response.responseStatus == ResponseStatus.Success) {
            this.isLoadingQBOData = false;
            response.result.forEach((element: any) => {
              if (element.stockDetail != null) {
                var stocks = element.stockDetail;
                element.stockDetail = [];
                from(stocks)
                  .pipe(distinct())
                  .subscribe((x) => element.stockDetail.push(x));
              }
            });
            this.quickbooksData = response.result;
            this.quickbooksDataCopy = JSON.parse(
              JSON.stringify(response.result)
            );
          } else {
            this.isLoadingQBOData = false;
            this._cS.displayMessage(
              ResponseMessageStatus.error,
              response.message
            );
          }
        }
      });
  }
  searchByBL() {
    this.quickbooksData = this.quickbooksDataCopy.filter((x: any) =>
      x.blStatus.toLowerCase().includes(this.searchTextBLStatus?.toLowerCase())
    );
  }
  getWooCommerceData() {
    this.isDataLoading = true;
    this.wooCommerceDataList_Request = this._blS
      .getOrdersWoocommerce(
        this.orderStatus,
        this.fromDateWOO,
        this.toDateWOO,
        1,
        100,
        '',
        'date',
        'desc'
      )
      .subscribe((response: any) => {
        if (response) {
          if (response.responseStatus == ResponseStatus.Success) {
            this.isDataLoading = false;
            // GetOrdersWoocommerce now returns a { items, total } envelope. This legacy page has no
            // pager, so it just renders the first page's items (client-side search/sort still apply).
            this.wooCommerceData = response.result?.items || [];
            this.wooCommerceDataCopy = JSON.parse(
              JSON.stringify(this.wooCommerceData)
            );
          } else {
            this.isDataLoading = false;
            this._cS.displayMessage(
              ResponseMessageStatus.error,
              response.message
            );
          }
        }
      });
  }
  showAssignmentModal(data: any, isEdit?: any) {
    this.isAssignmentVisible = true;
    if (isEdit == true) {
      this.editAssignmentDetail = data;
      this.assignemntForInvoice = null;
      this.editAssignmentDetail['assigmentDetails'] = true;
    } else {
      this.editAssignmentDetail = null;
      this.assignemntForInvoice = data;
    }
  }
  hideModal(event: any) {
    if (event.hide) {
      this.isAssignmentVisible = !event.hide;
    }
    if (event.data) {
      if (this.editAssignmentDetail) {
        var currentIndex = this.quickbooksData.findIndex(
          (x: any) => x.invoiceNumber == this.editAssignmentDetail.invoiceNumber
        );
      } else {
        var currentIndex = this.quickbooksData.findIndex(
          (x: any) => x.invoiceNumber == this.assignemntForInvoice.invoiceNumber
        );
      }
      this.quickbooksData[currentIndex].isAssigned = true;
      this.quickbooksData[currentIndex].assignmentId = event.data.id;
      // if (this.editAssignmentDetail) {
      //   var currentStockDetails = event.data.stocks;
      // } else {
      //   var currentStockDetails = event.data.assignmentStocks;
      // }

      var currentStockDetails = event.data.stocks
        ? event.data.stocks
        : event.data.assignmentStocks;

      this.quickbooksData[currentIndex].stockDetail = currentStockDetails?.map(
        (x: any) => {
          return x.stockName;
        }
      );
      this.assignemntForInvoice = null;
    }
  }
}
